<template>
  <main class="contenedor contenido-principal contenido-fondo sombra">
    <h2><span>Haz tu</span>reservación</h2>
    <div class="contenido-contacto">
      <form class="formulario">
        <div class="campo">
          <label for="nombre">Nombre:</label>
          <input type="text" id="nombre" placeholder="Tu nombre completo">
        </div>
        <div class="campo">
          <label for="email">Email:</label>
          <input type="email" id="email" placeholder="Tu email">
        </div>
        <div class="campo">
          <label for="celular">Celular:</label>
          <input pattern="[0-9]*" inputmode="numeric" id="celular" placeholder="Tu celular">
        </div>
        <div class="campo">
          <label for="personas">Número Personas:</label>
          <select name="personas" id="personas">
            <option value="" disabled selected>Seleccionar</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="mas">>6</option>
          </select>
        </div>
        <div class="campo">
            <label for="hora">Hora:</label>
            <input type="time" id="hora" min="09:00" max="20:00">
        </div>
        <div class="campo">
            <label for="fecha">Fecha:</label>
            <input type="date" id="fecha">
        </div>
        <div class="campo">
            <input type="submit" value="enviar">
        </div>
      </form>
    </div>
  </main>  
</template>

<style scoped>
@media (min-width: 768px) {
  .contenido-fondo {
    background-image: url(../../assets/img/granos_cafe.jpg);
    background-repeat: no-repeat;
    background-position: right center;
    background-size: auto;
  }
}
</style>